import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { initSentry } from "@/lib/sentry";
import { queryClient, bindQueryCacheToSession } from "@/lib/api/query-client";
import { Toaster } from "@/ui/sonner";
import { BrandStatusPage } from "@/components/BrandStatusPage";
import "./styles/globals.css";

initSentry();

// Switching accounts on a shared device must not leave the previous person's
// cached responses in place — see query-client.ts.
bindQueryCacheToSession();

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultNotFoundComponent: () => (
    <BrandStatusPage
      code="404"
      title="Trang này không có trong kho"
      description="Đường dẫn có thể đã đổi. Quay về trang chính để tiếp tục."
    />
  ),
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster richColors position="top-right" />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </StrictMode>,
);
